<template>
  <div class="user-avatar" @click="$router.push('/profile/setting')">
    <el-avatar
      src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"
    />
    <p class="user-avatar__name">
      {{ user.name }}
    </p>
  </div>
</template>

<script>
import ApiAuth from "@/api/auth";
export default {
  data() {
    return {
      user: {},
    };
  },
  mounted() {
    ApiAuth.getMe().then((responce) => {
      this.user = responce.data;
    });
  },
};
</script>